import { schema } from 'normalizr'
import { makeResponseSchema } from '../../utils/normalize'

export const activitySchema = new schema.Entity('activities', {}, {
  idAttribute: 'code'
})

export const activityListSchema = [activitySchema]
export const activityListResponseSchema = makeResponseSchema(activityListSchema)
